
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Helmet } from "react-helmet";



const ProductByBrand = () => {

    //#region Const 
    let { Id } = ReactDOM.useParams();
    let { Brand } = ReactDOM.useParams();
    const toaster = rsuite.useToaster();
    const navigate = ReactDOM.useNavigate();

    const [ProductList, setProductList] = React.useState([]);
    const [BrandIdList, setBrandIdList] = React.useState([Id]);
    const [GroupIdList, setGroupIdList] = React.useState([]);
    const [ParentIdList, setParentIdList] = React.useState([]);
    const [BeginPrice, setBeginPrice] = React.useState(-1);
    const [EndPrice, SetEndPrice] = React.useState(-1);
    const [BrandList, setBrandList] = React.useState([]);
    const [GroupList, setGroupList] = React.useState([]);
    const [PowerList, setPowerList] = React.useState([]);
    const [ParentList, setParentList] = React.useState([]);
    const [MinPrice, setMinPrice] = React.useState(0);
    const [MaxPrice, SetMaxPrice] = React.useState(100000000000000000000);

    const [Title, setTitle] = React.useState("");
    const [background, setbackground] = React.useState("");

    const GetProductParentGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/GetByIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'Id': 0,
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                const img = new Image();
                img.src = General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg';

                if (img.complete) {
                    setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg')
                } else {
                    img.onload = () => {
                        setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg')
                    };

                    img.onerror = () => {
                        setbackground('')
                    };
                }
            })
    }

    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/GetByIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'Id': Id,
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                const img = new Image();
                img.src = General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg';

                if (img.complete) {
                    setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg')
                } else {
                    img.onload = () => {
                        setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + Id + '_Img.jpg')
                    };

                    img.onerror = () => {
                        setbackground('')
                    };
                }
            })
    }

    const GetPrice = () => {
        fetch(General.ApiRoute() + '/Product/GetPrice', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                setMinPrice(result[0])
                SetMaxPrice(result[1])
            })
    }


    const GetPowerList = () => {
        fetch(General.ApiRoute() + '/Product/GetPowerForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'ParentId': ParentIdList,
                'GroupId': GroupIdList
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        Power: result[i].power,
                    })
                }
                setPowerList(tmp)
            })
    }


    const GetProductBrand = () => {
        fetch(General.ApiRoute() + '/ProductBrand/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {

                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        id: result[i].id,
                        title: result[i].title,
                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Brand/' + result[i].id + '.jpg',

                    })
                }
                setBrandList(tmp)
            })
    }

    const GetProduct = () => {
        fetch(General.ApiRoute() + '/Product/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1,
                'ProductGroupId': GroupIdList,
                'BrandId': BrandIdList,
                'ProductGroupParentId': ParentList,
                'Title': Title,
                'BeginPrice': BeginPrice,
                'EndPrice': EndPrice,
                'Power': PowerList,
                'Current': -1

            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                console.dir(result)
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        Id: result[i].id,
                        Title: result[i].title,
                        // ParentId: result[i].parentId,
                        SaleType: result[i].saleType,
                        LastPrice: result[i].lastPrice,
                        ParentTitle: result[i].parentTitle,
                        GroupTitle: result[i].groupTitle,
                        BrandTitle: result[i].brandTitle,
                        Comment: result[i].comment,
                        Power: result[i].power,
                        Current: result[i].current,
                        SaleCount: result[i].saleCount * 1,
                        IdentityNo: result[i].identityNo,
                        photoTag: result[i].photoTag,
                        PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',


                    })
                }
                console.dir(tmp)
                setProductList(tmp)
            })
    }

    const ShowProduct = (id, title, Parent, Group) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", true);
        localStorage.setItem("BySuggestion", false);
        localStorage.setItem("ByCompare", false);

        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        navigate('/ProductInfo/' + parent + "/" + group + "/" + Newproduct);

        // navigate('/ProductInfo/' + Parent + "/" + Group + "/" + title)

    }
    const NavigatePage = (url) => {
        navigate(url)

    }

    //#endregion
    React.useEffect(() => {
        // GetProductGroup();
        // GetProductBrand();
        GetProduct();
        // GetPowerList();
        // GetPrice();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");

        document.title = Brand;
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                // className={styles.article}
                style={{
                    backgroundImage: `url(${background})`
                    , background: `linear-gradient(90deg, rgba(47,72,88,1) 0%, rgba(76,114,139,1) 27%, rgba(251,250,250,1) 67%)`
                }}
            >
            </div>

            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>
                {Brand}
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item onClick={() => NavigatePage("/")}>
                        خانه
                    </rsuite.Breadcrumb.Item>
                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>{Brand}</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Grid className="pt-3">



                <rsuite.Row className="justify-content-center align-items-center pt-5">

                    {ProductList.map((group) =>

                        <rsuite.Col xs={24} sm={24} md={12} lg={12} className="p-2">

                            <rsuite.Card className="w-100p " shaded direction="row" >

                                <rsuite.Image
                                    src={group.PhotoUrl}
                                    fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                    alt={group.PhotoTag}
                                    placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: 'auto' }} />
                                    }
                                    style={{ width: '150px', height: '185px' }}
                                    className="border-radius-half Cursor"

                                    onClick={() => ShowProduct(group.Id, group.Title, group.GroupTitle, group.ParentTitle)}
                                />
                                <rsuite.VStack spacing={2} >
                                    <rsuite.Card.Header as="h5" className="Cursor" onClick={() => ShowProduct(group.Id, group.Title, group.groupTitle, group.parentTitle)}>{group.Title}</rsuite.Card.Header>
                                    <rsuite.Card.Body className="Cursor" onClick={() => ShowProduct(group.Id, group.Title, group.groupTitle, group.parentTitle)} >
                                        <p className="Font14"><b>برند </b> {group.BrandTitle}</p>
                                        {group.SaleType != 3 ?
                                            <b>
                                                قیمت :  {PN.sliceNumber(group.LastPrice)} ریال
                                            </b>

                                            // : <> قیمت در دسترس نمی باشد</>
                                            : <b className="text-danger"> قیمت در حال به روزرسانی  </b>
                                        }

                                    </rsuite.Card.Body>
                                    <rsuite.Card.Footer>
                                        <rsuite.TagGroup>
                                            {group.SaleCount > 0 && group.SaleType == 1 ?
                                                <rsuite.Tag size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {group.SaleCount}</rsuite.Tag>

                                                : group.SaleCount == 0 && group.SaleType == 1 ?
                                                    <rsuite.Tag size="sm"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                    : group.SaleType == 2 ?
                                                        <rsuite.Tag size="sm"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '30px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                        : group.SaleType == 3 ?
                                                            <rsuite.Tag size="sm"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '30px' }} />فروش بسته می باشد</rsuite.Tag>
                                                            :
                                                            <></>
                                            }

                                        </rsuite.TagGroup>
                                        <div>
                                            <rsuite.Button color="green" disabled={(group.SaleCount > 0 && group.SaleType == 1) || group.SaleType == 2 ? false : true} appearance="primary" block>  اضافه به سبد خرید </rsuite.Button>

                                        </div>

                                    </rsuite.Card.Footer>
                                </rsuite.VStack>
                            </rsuite.Card>



                        </rsuite.Col>
                    )}
                </rsuite.Row>
            </rsuite.Grid>


        </Layout >
    )
}

export default ProductByBrand;